const partners = [
  { name: "Google for Education", icon: "ri-google-fill" },
  { name: "Microsoft Education", icon: "ri-microsoft-fill" },
  { name: "AWS Educate", icon: "ri-amazon-fill" },
  { name: "NVIDIA Deep Learning", icon: "ri-cpu-line" },
  { name: "Autodesk", icon: "ri-box-3-line" },
  { name: "Arduino", icon: "ri-settings-3-line" },
  { name: "Raspberry Pi", icon: "ri-cpu-line" },
  { name: "Blynk", icon: "ri-wifi-line" },
  { name: "ARM Microcontrollers", icon: "ri-cpu-line" },
  { name: "ESP8266 / ESP32", icon: "ri-wifi-line" },
  { name: "Tinkercad", icon: "ri-box-3-line" },
  { name: "MATLAB", icon: "ri-bar-chart-box-line" },
  { name: "Proteus", icon: "ri-cpu-line" },
  { name: "Open AI", icon: "ri-message-3-line" },
  { name: "Google Gemini", icon: "ri-sparkling-line" },
  { name: "Claude", icon: "ri-message-3-line" },
  { name: "LLM", icon: "ri-brain-line" },
  { name: "AI Agents", icon: "ri-robot-2-line" },
  { name: "RAG", icon: "ri-database-2-line" },
  { name: "MLOps", icon: "ri-server-line" },
  { name: "ML", icon: "ri-brain-line" },
  { name: "Database", icon: "ri-database-line" },
  { name: "Fullstack", icon: "ri-stack-line" },
  { name: "Robotics", icon: "ri-robot-2-line" },
];

export default function CorporateTestimonials() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Technology Ecosystem */}
        <div className="bg-gray-50 rounded-2xl p-8 md:p-12">
          <div className="text-center mb-10">
            <h3 className="text-2xl font-bold text-gray-900 mb-2">Technology Ecosystem</h3>
            <p className="text-gray-600">Powered by industry-leading technology platforms</p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-6">
            {partners.map((partner, idx) => (
              <div
                key={idx}
                className="bg-white rounded-xl p-6 text-center hover:shadow-md transition-shadow duration-300 border border-gray-100"
              >
                <div className="w-12 h-12 rounded-full bg-emerald-50 flex items-center justify-center mx-auto mb-3">
                  <i className={`${partner.icon} text-2xl text-emerald-600`}></i>
                </div>
                <div className="text-sm font-medium text-gray-800">{partner.name}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
